 <div>   
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form
    #df="ngForm"
    novalidate
    class="formborder"
  >
    <div class="row m-0 align-items-end w-100 p-0">
      <div class="col-md-3">
        <span>Select Process</span>
        <select
          name="ProcessId"
          id="ProcessId"
          [(ngModel)]="ProcessIds"
          class="form-control input-text-css"
        >
          <option value = 0>Select Process</option>
          <option *ngFor="let item of ProcessDropdown" [value]="item.ProcessId">
            {{ item.Process_Name }}
          </option>
        </select>
      </div>
  
     <div class="col-md-2">
      <span>Branch</span>
      <ng-multiselect-dropdown
        class="process-employee-multiselect"
        name="BranchId"
        id="BranchId"
        #refBranchId="ngModel"
        [(ngModel)]="BranchId"
        [placeholder]="'Select Branch'"
        [data]="BranchesList"
        [settings]="branchDropdownSettings"
        (onDropDownClose)="onBranchSelectionChange()"
      >
      </ng-multiselect-dropdown>
    </div>

     <div class="col-md-2">
      <span>Product</span>
      <ng-multiselect-dropdown
        class="process-employee-multiselect"
        name="ProductId"
        id="ProductId"
        #refProductId="ngModel"
        [(ngModel)]="ProductId"
        [placeholder]="'Select Product'"
        [data]="ProductList"
        [settings]="productDropdownSettings"
        (onDropDownClose)="onProductSelectionChange()"
      >
      </ng-multiselect-dropdown>
    </div> 

      <div class="col-md-2">
        <span class="d-block" style="visibility: hidden;">&nbsp;</span>
        <button
          type="button"
          (click)="OnSearchProcessEmployee()"
          class="btn font-size-12 button-btn"
          style="height: 2rem; margin-bottom: 0.75rem !important;"
          [disabled]="!df.form.valid"
        >
          Search
        </button>
      </div>
      
    </div>
  </form>

  <mat-tab-group class="employee-tab mt-3" *ngIf="AssignedDataSource || UnassignedDataSource" (selectedTabChange)="onTabChange($event)">

    <mat-tab label="Assigned">
      <ng-template mat-tab-label>
        <span>Assigned</span>
      </ng-template>

      <div class="employee-tab-body">
        <div class="table-responsive">
          <mat-table
            [dataSource]="AssignedDataSource"
            matSort
            matTableExporter
            #exporterAssigned="matTableExporter"
            style="width: 100%; overflow: auto"
          >
            <ng-container matColumnDef="EmpId">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef style="max-width: 3.125rem">#</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell mw50">{{ i + 1 }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Employee_Name">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Employee Name</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Employee_Name }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Role_Name">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Role Name</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Role_Name }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Action">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Action</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                <button type="button" class="btn btn-sm btn-danger font-size-12" (click)="openConfirmModal(row, 'Unassign')">
                  <i class="fas fa-user-minus"></i> Unassign
                </button>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="AssigneddisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: AssigneddisplayedColumns"></mat-row>
          </mat-table>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Unassigned">
      <ng-template mat-tab-label>
        <span>Unassigned</span>
      </ng-template>

      <div class="employee-tab-body">
        <div class="table-responsive">
          <mat-table
            [dataSource]="UnassignedDataSource"
            matSort
            matTableExporter
            #exporterUnassigned="matTableExporter"
            style="width: 100%; overflow: auto"
          >
            <ng-container matColumnDef="EmpId">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef style="max-width: 3.125rem">#</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell mw50">{{ i + 1 }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Employee_Name">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Employee Name</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Employee_Name }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Role_Name">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Role Name</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Role_Name }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Action">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Action</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                <button type="button" class="btn btn-sm btn-success font-size-12" (click)="openConfirmModal(row, 'Assign')">
                  <i class="fas fa-user-plus"></i> Assign
                </button>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="UnassigneddisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: UnassigneddisplayedColumns"></mat-row>
          </mat-table>
        </div>
      </div>
    </mat-tab>

  </mat-tab-group>

  <!-- Confirmation Modal -->
  <div class="modal fade in" id="confirmActionModal" tabindex="-1" role="dialog" aria-labelledby="confirmActionModalLabel" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
    <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
          <h6 class="modal-title" id="confirmActionModalLabel">Confirmation</h6>
          <button type="button" (click)="onCancelConfirmModal()" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
          </button>
        </div>

        <div class="modal-body text-center">
          <p class="mb-0">
            Are you sure you want to  {{ isAssignMode ? 'Assign' : 'Unassign' }}
            <strong>{{ selectedEmployee?.Employee_Name }}</strong> for
            {{ selectedProcessName }} process ?
          </p>
        </div>

        <div class="modal-footer justify-content-center" style="border: none; padding-top:0; gap: 0.625rem;">
          <button type="button" (click)="onCancelConfirmModal()" class="btn font-size-12 button-btn" data-dismiss="modal" style="min-width: 5.625rem; padding: 0.5625rem 1rem;">Cancel</button>
          <button type="button" (click)="onConfirmAction()" class="btn font-size-12 button-btn" data-dismiss="modal"
            [style.background]="isAssignMode ? '#28a745' : '#dc3545'"
            style="min-width: 5.625rem; padding: 0.5625rem 1rem;">
            {{ isAssignMode ? 'Assign' : 'Unassign' }}
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>

